import ScrollTrigger from 'gsap/ScrollTrigger';
import { getClinicsCity } from '../api/clinics';
import { initClinicsMap } from './clinicsMap';

export async function initFooterMap() {
  const parent = document.querySelector('.footer__map');
  if (!parent) return;

  const mapOptions = {
    fitPadding: {
      mobile: { top: 0.08, right: 0.1, bottom: 0.9, left: 0.1 },
      desktop: { top: 0.08, right: 0.08, bottom: 0.5, left: 0.08 },
    },
  };

  const city = await getClinicsCity(0);
  const clinics = city.clinics;

  ScrollTrigger.create({
    trigger: parent,
    start: 'top-=1000 bottom',
    once: true,
    onEnter: async () => {
      const map = await initClinicsMap(parent, mapOptions);

      map.showPlaces(clinics);

      const select = document.querySelector('.footer__select select');
      if (select) {
        select.addEventListener('change', async () => {
          const city = await getClinicsCity(select.value);
          const clinics = city.clinics;
          map.showPlaces(clinics);
        });
      }
    },
  });
}
